import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconContext } from 'react-icons';
import { FaXTwitter, FaInstagram, FaThreads, FaPinterestP } from 'react-icons/fa6';
import HomeIcon from './HomeIcon';
import { containerSx } from '../components/Section';
import { COMPANY, NAV_ITEMS, AREA_ITEMS, URL_IN, URL_TW, URL_TH, URL_PI } from '../../Const';

const columnHeadingSx = {
  fontFamily: "'Noto Serif JP', serif",
  fontWeight: 500,
  fontSize: 15,
  lineHeight: 1.7,
  letterSpacing: '.16em',
  color: '#ffffff',
  mb: 2.5,
};

const linkSx = {
  color: 'rgba(255,255,255,.7)',
  fontSize: 14,
  letterSpacing: '.06em',
  textDecoration: 'none',
  transition: 'color .25s',
  '&:hover': { color: '#ffffff' },
};

const snsLinks = [
  { url: URL_IN, label: 'Instagram', Icon: FaInstagram },
  { url: URL_TH, label: 'Threads', Icon: FaThreads },
  { url: URL_TW, label: 'X', Icon: FaXTwitter },
  { url: URL_PI, label: 'Pinterest', Icon: FaPinterestP },
];

function LinkColumn({ title, items }) {
  return (
    <Box>
      <Typography component="h2" sx={columnHeadingSx}>
        {title}
      </Typography>
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {items.map((item) => (
          <li key={item.label}>
            <Box component="a" href={item.href} sx={linkSx}>
              {item.label}
            </Box>
          </li>
        ))}
      </Box>
    </Box>
  );
}

export default function AppFooter() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'sumiDeep',
        color: 'rgba(255,255,255,.85)',
        pt: { xs: 7, sm: 10 },
      }}
    >
      <Box sx={containerSx}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1.4fr 1fr 1fr' },
            gap: { xs: 5, sm: 8 },
            pb: { xs: 6, sm: 8 },
          }}
        >
          <Box>
            <HomeIcon variant="footer" />
            <Typography
              sx={{
                fontSize: 14,
                lineHeight: 2,
                color: 'rgba(255,255,255,.7)',
                mt: 2.5,
              }}
            >
              {COMPANY.name}
              <br />
              {COMPANY.zip} {COMPANY.address}
              <br />
              <Box component="a" href={`tel:${COMPANY.tel}`} sx={{ ...linkSx, fontSize: 'inherit' }}>
                TEL {COMPANY.tel}
              </Box>
              {' ／ '}
              FAX {COMPANY.fax}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2.5, mt: 3 }}>
              <IconContext.Provider value={{ size: '22px' }}>
                {snsLinks.map(({ url, label, Icon }) => (
                  <Box
                    key={label}
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    sx={{ ...linkSx, display: 'flex' }}
                  >
                    <Icon />
                  </Box>
                ))}
              </IconContext.Provider>
            </Box>
          </Box>

          <LinkColumn title="サイトマップ" items={[...NAV_ITEMS, { label: 'お問い合わせ', href: '/contact' }]} />
          <LinkColumn title="対応エリア" items={AREA_ITEMS} />
        </Box>

        <Box
          sx={{
            borderTop: '1px solid rgba(255,255,255,.12)',
            py: 3,
            fontSize: 12,
            letterSpacing: '.08em',
            color: 'rgba(255,255,255,.45)',
            textAlign: 'center',
          }}
        >
          {/* プライバシーポリシー / 利用規約は実文書が用意でき次第、ここにリンクを追加する */}
          © 飯田建築有限会社
        </Box>
      </Box>
    </Box>
  );
}
